import { SelectOption } from '@globaleris/ui.library'
import { EnumCommodity, EnumTipoPeaje } from '../../api'
import { EnumGetAnnexedParamsType } from './procedures.types'

export const UPDATE_OWNER_CHANGE_REASONS_PWR = ['T', 'S'] as const

export const UPDATE_OWNER_CHANGE_REASONS_GAS = [
  '01',
  '12',
  '14',
  '16',
  '17',
  '19',
  '21',
  '23'
] as const

export const PRINCIPAL_RESIDENCE_ADM_CHANGE_PWR = ['T', 'S', 'A']

export const GAS_UPDATE_OWNER_VALUES = ['01', '12', '14', '16', '17', '19', '21', '23']

// Change reasons for administrative changes - PWR
export const CHANGE_REASONS_ADM_CHANGE_PWR = ['A', 'C', 'D', 'P', 'R', 'U']
export const CHANGE_REASONS_ADM_CHANGE_PWR_ALL = ['A', 'C', 'D', 'P', 'R', 'U']
export const CHANGE_REASONS_UPDATE_OWNER_PWR = ['T', 'S']

// Change reasons for administrative/technical changes - GAS
export const CHANGE_REASONS_ADM_CHANGE_GAS = ['04', '09', '10', '26', '27', '28']

// Change reasons for update owner with technical changes - GAS
export const CHANGE_REASONS_UPDATE_OWNER_ADM_TEC_GAS = ['12', '14', '16', '19', '21', '23']

// Change reasons for update owner - GAS
export const CHANGE_REASONS_UPDATE_OWNER_GAS = ['01', '17']

export const CHANGE_REASONS_ADM_TEC_CHANGE_GAS = ['18', '20', '22']

export const CHANGE_REASONS_TEC_CHANGE_GAS = ['11', '13', '15']

export const VALID_TOLLTYPE: Array<EnumTipoPeaje> = [
  EnumTipoPeaje.Peaje_B5,
  EnumTipoPeaje.Peaje_A5,
  EnumTipoPeaje.Peaje_B6,
  EnumTipoPeaje.Peaje_A6,
  EnumTipoPeaje.Peaje_B7,
  EnumTipoPeaje.Peaje_A7,
  EnumTipoPeaje.Peaje_R8,
  EnumTipoPeaje.Peaje_R9,
  EnumTipoPeaje.Peaje_R10,
  EnumTipoPeaje.Peaje_R11,
  EnumTipoPeaje.Peaje_R4,
  EnumTipoPeaje.Peaje_R5,
  EnumTipoPeaje.Peaje_R6,
  EnumTipoPeaje.Peaje_R7
]

const complaintSubTypeMatrixGas = [
  // 21 Gas Tramitacion, 22 Gas Factura, 23 Gas CUPS
  [92, 0, 0], // 1 ATENCION PERSONAL
  [0, 94, 93], // 2 FACTURACION Y MEDIDA
  [97, 0, 0], // 3 CONTRATACION
  [98, 0, 0] // 7 ATENCION REGLAMENTARIA
]

const complaintSubTypeMatrixPower = [
  // 24 Pwr Tramitacion, 25 Pwr Factura, 26 Pwr CUPS
  [99, 0, 0], // 1 ATENCION PERSONAL
  [0, 101, 100], // 2 FACTURACION Y MEDIDA
  [104, 0, 0], // 3 CONTRATACION
  [105, 0, 0] // 7 ATENCION REGLAMENTARIA
]

const rowMap = new Map([
  ['01', { title: 'ATENCION PERSONAL', row: 0 }],
  ['02', { title: 'FACTURACION Y MEDIDA', row: 1 }],
  ['03', { title: 'CONTRATACION', row: 2 }],
  ['07', { title: 'ATENCION REGLAMENTARIA', row: 3 }]
])

const columnMap = new Map([
  [21, { title: 'Reclamación Gas Tramitación', column: 0 }],
  [22, { title: 'Reclamación Gas Factura', column: 1 }],
  [23, { title: 'Reclamación Gas CUPS', column: 2 }],
  [24, { title: 'Reclamación Pwr Tramitación', column: 0 }],
  [25, { title: 'Reclamación Pwr Factura', column: 1 }],
  [26, { title: 'Reclamación Pwr CUPS', column: 2 }]
])

export const getComplaintSubTypeByCategory = (
  complaintType: string,
  context: number,
  commodity: EnumCommodity
): number => {
  const rowIndex = translateOptionToIndex(complaintType, 'row')
  const columnIndex = translateOptionToIndex(context, 'column')

  if (rowIndex !== undefined && columnIndex !== undefined) {
    if (commodity === EnumCommodity.GasNatural)
      return complaintSubTypeMatrixGas[rowIndex][columnIndex]
    else if (commodity === EnumCommodity.Electricidad)
      return complaintSubTypeMatrixPower[rowIndex][columnIndex]
    else return 0
  } else {
    return 0
  }
}

const translateOptionToIndex = (value: string | number, mapType: 'row' | 'column') => {
  if (mapType === 'row') {
    return rowMap.get(value.toString())?.row
  } else if (mapType === 'column') {
    return columnMap.get(+value)?.column
  } else {
    return undefined
  }
}

export const filterBySubComplaintType = (
  complaintTypeList: SelectOption[],
  context: number,
  commodity: EnumCommodity
) => {
  return complaintTypeList.filter(option => {
    const subType = getComplaintSubTypeByCategory(option.value.toString(), context, commodity)
    return subType !== 0
  })
}

export const getChangeReasonsValuesGas = (fetchType: EnumGetAnnexedParamsType | null): string[] => {
  switch (fetchType) {
    case EnumGetAnnexedParamsType.ADMINISTRATIVE_CHANGE_GAS:
      return CHANGE_REASONS_ADM_CHANGE_GAS
    case EnumGetAnnexedParamsType.ADMINISTRATIVE_TECHNICAL_CHANGE_GAS:
      return CHANGE_REASONS_ADM_TEC_CHANGE_GAS
    case EnumGetAnnexedParamsType.UPDATE_OWNER_ADM_TEC_GAS:
      return CHANGE_REASONS_UPDATE_OWNER_ADM_TEC_GAS
    case EnumGetAnnexedParamsType.UPDATE_OWNER_GAS:
      return CHANGE_REASONS_UPDATE_OWNER_GAS
    case EnumGetAnnexedParamsType.TECHNICAL_CHANGE_GAS:
      return CHANGE_REASONS_TEC_CHANGE_GAS
    default:
      return []
  }
}
